const CircleArrowUp = (
    <g
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        stroke="currentColor"
    >
        <polyline points="6.5 8.25 9 5.75 11.5 8.25"></polyline>
        <line x1="9" y1="5.75" x2="9" y2="12.25"></line>
        <circle cx="9" cy="9" r="7.25"></circle>
    </g>
);

export { CircleArrowUp };
